"use client"

import { PanelLeftRightDashed } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PanelLeftRightDashedIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PanelLeftRightDashedIcon = component(Icon)({
  as: PanelLeftRightDashed,
})
